import React from "react";

function UpdateButton({ onClick }) {
  return (
    <div>
      <button
        onClick={onClick}
        type="submit"
        className="h-9 px-3  bg-green-600 text-white rounded text-sm font-medium"
      >
        Update
      </button>
    </div>
  );
}

export default UpdateButton;
